import css from './FragmentInfoHeaderStep3.module.css';
import React, { useState } from 'react';
import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import ItemProgressBar from '@shared/Ui/ProgressBars/ItemProgressBar/ItemProgressBar';
import CircularArrowsIcon from '@shared/Icons/CircularArrowsIcon';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { CustomProjectStep3ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep3ElementsIdsEnum';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';

interface Props {
    fragment: ParsedFragmentEntity;
    isSelectAllDisabled?: boolean;
    isClearAllDisabled?: boolean;
}

export const FragmentInfoHeaderStep3: React.FC<Props> = ({
    fragment,
    isSelectAllDisabled,
    isClearAllDisabled,
}) => {
    const { id, progress, title, uuid } = fragment;

    const fragmentsViewModel = new FragmentsViewModel();
    const selectedItemsViewModel = new ItemsSelectionViewModel();
    const url = fragmentsViewModel.getFragmentGallery(id);

    const [clearSelectionAnimation, setClearSelectionAnimation] =
        useState(false);

    const handleSelectAll = () => {
        selectedItemsViewModel.selectAllFragmentItems(uuid);
    };

    const handleClearSelection = () => {
        selectedItemsViewModel.removeAllFragmentItemsFromSelected(uuid);
        setClearSelectionAnimation(true);
        setTimeout(() => setClearSelectionAnimation(false), 300);
    };

    return (
        <div className={css.fragmentInfo}>
            <img src={url} alt="fragment-img" className={css.image} />
            <div className={css.titleContainer}>
                <div className={css.title}>{title}</div>
            </div>

            <div className={css.progressBar}>
                <ItemProgressBar
                    total={100}
                    current={progress ?? 0}
                    selectedNotify={'%'}
                />
            </div>

            <div className={css.buttons}>
                <BasicButton
                    onClick={handleSelectAll}
                    extraClassName={css.selectAllBtn}
                    id={
                        CustomProjectStep3ElementsIdsEnum.WORK_AREA_STEP3_SELECT_ALL_FRAGMENT_BUTTON
                    }
                    disabled={isSelectAllDisabled}
                >
                    Select all
                </BasicButton>
                <BasicButton
                    onClick={handleClearSelection}
                    extraClassName={css.clearSelectionBtn}
                    id={
                        CustomProjectStep3ElementsIdsEnum.WORK_AREA_STEP3_CLEAR_ALL_FRAGMENT_BUTTON
                    }
                    disabled={isClearAllDisabled}
                    children={
                        <>
                            <CircularArrowsIcon
                                height={18}
                                width={18}
                                fill="currentColor"
                                className={
                                    clearSelectionAnimation
                                        ? css.clearSelectionBtnRotatedIcon
                                        : css.clearSelectionBtnIcon
                                }
                            />
                            Clear fragment
                        </>
                    }
                />
            </div>
        </div>
    );
};
